import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './Presets.css'
import CogIcon from 'react-icons/lib/fa/cog'
import getResearchQueryPresets from '$src/api/endpoints/researchQueryPresets/getResearchQueryPresets'
import {keyBy} from 'lodash'
import {applySnapshot, getSnapshot} from 'mobx-state-tree'
import {Form} from '$src/common/forms'
import TextInput from '$src/common/TextInput'
import GenericButton from '$src/common/GenericButton'
import {ResearchStateTab, ResearchQueryPreset} from '$src/bootstrap/Store'
import createResearchQueryPreset from '$src/api/endpoints/researchQueryPresets/createResearchQueryPreset'
import DeleteIcon from 'react-icons/lib/fa/trash-o'
import deleteResearchQueryPreset from '$src/api/endpoints/researchQueryPresets/deleteResearchQueryPreset';

interface Props {
  activeTabState: typeof ResearchStateTab.Type
  css?: any
}

interface State {
  open: boolean
  formKey: number
  formSubmitting: boolean
  formError?: string
}
const classes = resolveCss(css)

@observer
export default class Presets extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {open: false, formKey: 1, formSubmitting: false, formError: null}

    this.load()
  }

  incrementFormKey = () => {
    this.setState({formKey: this.state.formKey + 1})
  }

  load = async () => {
    if (!this.store) return
    let result
    try {
      result = await this.callEndpoint(getResearchQueryPresets)
    } catch (e) {
      console.error(e)
      this.store.researchQueryPresets.setStatus('Failed')
      return
    }

    const presets = result.filter((s: any) => s && s.version && s.version === 1)
    const byId = keyBy(presets, '_id')
    const list = presets.map(({_id}) => _id)

    applySnapshot(this.store.researchQueryPresets, {
      status: 'Loaded',
      byId,
      list,
    })
  }

  render() {
    const {props, state} = this
    const {status} = this.store.researchQueryPresets

    return (
      <div {...classes('container', state.open && 'open')}>
        <div {...classes('header')} onClick={this.toggleOpen}>
          Filters
          <div {...classes('iconContainer')}>
            <CogIcon />
          </div>
        </div>
        <div {...classes('expandedAreaWrapper')}>
          {status === 'Loaded' ? (
            this.renderBody()
          ) : (
            <div {...classes('loadingMessage', 'status' + status)}>{status}</div>
          )}
        </div>
      </div>
    )
  }

  toggleOpen = () => {
    this.setState({open: !this.state.open})
  }

  renderBody() {
    return (
      <>
        {this.renderList()}
        {this.renderForm()}
      </>
    )
  }

  renderList() {
    return (
      <>
        <div {...classes('heading')}>Existing presets</div>
        <div {...classes('list')}>
          {this.store.researchQueryPresets.list.map(id => {
            const s = this.store.researchQueryPresets.byId.get(id)
            return (
              <div {...classes('listItem')} key={`listItem-${id}`}>
                <div {...classes('name')} onClick={() => this.applyPreset(s)}>
                  {s.name}
                </div>
                <div
                  {...classes('deleteItem')}
                  onClick={() => {
                    this.deletePreset(id)
                  }}
                >
                  <DeleteIcon />
                </div>
              </div>
            )
          })}
        </div>
      </>
    )
  }

  deletePreset = async (id: string) => {
    try {
      await this.callEndpoint(deleteResearchQueryPreset, id)
    } catch (e) {
      console.error(e)
      return
    }

    this.store.researchQueryPresets.remove(id)
  }

  applyPreset = (s: typeof ResearchQueryPreset.Type) => {
    const {formValues} = getSnapshot(s)
    applySnapshot(this.props.activeTabState.query.formValues, formValues)
    this.setState({open: false})
  }

  submitForm = async (fields: any) => {
    if (this.state.formSubmitting) return

    const {name} = fields
    if (!(typeof name === 'string' && name.trim().length > 0)) {
      this.setState({formError: 'Enter a valid name for this preset'})
      return
    }

    this.setState({formSubmitting: true, formError: undefined})

    const formValues = getSnapshot(this.props.activeTabState.query.formValues)
    const args = {name, formValues, version: 1}

    let result
    try {
      result = await this.callEndpoint(createResearchQueryPreset, args)
    } catch (e) {
      this.setState({formSubmitting: false, formError: e.message})
      return
    }

    this.store.researchQueryPresets.add(result)
  }

  renderForm() {
    return (
      <div {...classes('theForm')}>
        <div {...classes('heading')}>Save current filter</div>
        <div {...classes('formBody')}>
          <Form key={`form-${this.state.formKey}`} onSubmit={this.submitForm}>
            <TextInput.Field
              name="name"
              style="small"
              placeholder="Preset name (unique)"
              css={{input: css.nameInput}}
            />
            {this.state.formError && <div {...classes('formError')}>{this.state.formError}</div>}
            <GenericButton type="submit" variant="smallbold" disabled={this.state.formSubmitting}>
              Create Preset
            </GenericButton>
          </Form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/Presets/Presets.tsx